@file:OptIn(InternalResourceApi::class)

package com.hyperether.goodjob.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/com.hyperether.goodjob.resources/"

public val Res.string.never: StringResource by lazy {
      StringResource("string:never", "never", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17921, 17),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15821, 21),
      ))
    }

public val Res.string.new_password: StringResource by lazy {
      StringResource("string:new_password", "new_password", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17939, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15843, 36),
      ))
    }

public val Res.string.new_workspace: StringResource by lazy {
      StringResource("string:new_workspace", "new_workspace", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 17980, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15880, 41),
      ))
    }

public val Res.string.newest: StringResource by lazy {
      StringResource("string:newest", "newest", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18030, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15922, 22),
      ))
    }

public val Res.string.next: StringResource by lazy {
      StringResource("string:next", "next", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18057, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15945, 20),
      ))
    }

public val Res.string.no: StringResource by lazy {
      StringResource("string:no", "no", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21084, 18),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18452, 14),
      ))
    }

public val Res.string.no_completion_report: StringResource by lazy {
      StringResource("string:no_completion_report", "no_completion_report", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18078, 64),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 15966, 60),
      ))
    }

public val Res.string.no_contacts_available: StringResource by lazy {
      StringResource("string:no_contacts_available", "no_contacts_available", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18143, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16027, 57),
      ))
    }

public val Res.string.no_damage: StringResource by lazy {
      StringResource("string:no_damage", "no_damage", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18205, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16085, 29),
      ))
    }

public val Res.string.no_data_received: StringResource by lazy {
      StringResource("string:no_data_received", "no_data_received", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18239, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16115, 48),
      ))
    }

public val Res.string.no_dates_selected: StringResource by lazy {
      StringResource("string:no_dates_selected", "no_dates_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18292, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16164, 49),
      ))
    }

public val Res.string.no_employees_added: StringResource by lazy {
      StringResource("string:no_employees_added", "no_employees_added", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18354, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16214, 50),
      ))
    }

public val Res.string.no_hours_available: StringResource by lazy {
      StringResource("string:no_hours_available", "no_hours_available", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18421, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16265, 50),
      ))
    }

public val Res.string.no_industries_available: StringResource by lazy {
      StringResource("string:no_industries_available", "no_industries_available", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18480, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16316, 111),
      ))
    }

public val Res.string.no_information: StringResource by lazy {
      StringResource("string:no_information", "no_information", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18612, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16428, 42),
      ))
    }

public val Res.string.no_matching_industries: StringResource by lazy {
      StringResource("string:no_matching_industries", "no_matching_industries", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18659, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16471, 82),
      ))
    }

public val Res.string.no_matching_skills: StringResource by lazy {
      StringResource("string:no_matching_skills", "no_matching_skills", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18782, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16554, 74),
      ))
    }

public val Res.string.no_matching_teams: StringResource by lazy {
      StringResource("string:no_matching_teams", "no_matching_teams", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18893, 101),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16629, 73),
      ))
    }

public val Res.string.no_plan_selected: StringResource by lazy {
      StringResource("string:no_plan_selected", "no_plan_selected", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 18995, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16703, 48),
      ))
    }

public val Res.string.no_skills_available: StringResource by lazy {
      StringResource("string:no_skills_available", "no_skills_available", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19048, 131),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16752, 99),
      ))
    }

public val Res.string.no_tasks_assigned: StringResource by lazy {
      StringResource("string:no_tasks_assigned", "no_tasks_assigned", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19180, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 16852, 153),
      ))
    }

public val Res.string.no_tasks_created: StringResource by lazy {
      StringResource("string:no_tasks_created", "no_tasks_created", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19342, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17006, 48),
      ))
    }

public val Res.string.no_tasks_text: StringResource by lazy {
      StringResource("string:no_tasks_text", "no_tasks_text", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19582, 169),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17186, 129),
      ))
    }

public val Res.string.no_tasks_text_employee: StringResource by lazy {
      StringResource("string:no_tasks_text_employee", "no_tasks_text_employee", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19399, 182),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17055, 130),
      ))
    }

public val Res.string.no_tasks_yet: StringResource by lazy {
      StringResource("string:no_tasks_yet", "no_tasks_yet", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19752, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17316, 36),
      ))
    }

public val Res.string.no_teams_available: StringResource by lazy {
      StringResource("string:no_teams_available", "no_teams_available", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19801, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17353, 98),
      ))
    }

public val Res.string.no_working_hours_available: StringResource by lazy {
      StringResource("string:no_working_hours_available", "no_working_hours_available", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 19924, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17452, 70),
      ))
    }

public val Res.string.no_worries: StringResource by lazy {
      StringResource("string:no_worries", "no_worries", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20003, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17523, 66),
      ))
    }

public val Res.string.not_assigned: StringResource by lazy {
      StringResource("string:not_assigned", "not_assigned", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20062, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17590, 36),
      ))
    }

public val Res.string.not_possible_to_buy_plan: StringResource by lazy {
      StringResource("string:not_possible_to_buy_plan", "not_possible_to_buy_plan", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20107, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17627, 96),
      ))
    }

public val Res.string.not_scheduled: StringResource by lazy {
      StringResource("string:not_scheduled", "not_scheduled", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20212, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17724, 41),
      ))
    }

public val Res.string.note_added_successfully: StringResource by lazy {
      StringResource("string:note_added_successfully", "note_added_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20254, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17766, 63),
      ))
    }

public val Res.string.note_deleted_successfully: StringResource by lazy {
      StringResource("string:note_deleted_successfully", "note_deleted_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20326, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17830, 69),
      ))
    }

public val Res.string.note_empty: StringResource by lazy {
      StringResource("string:note_empty", "note_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20404, 342),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 17900, 246),
      ))
    }

public val Res.string.note_updated_successfully: StringResource by lazy {
      StringResource("string:note_updated_successfully", "note_updated_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20747, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18147, 69),
      ))
    }

public val Res.string.notes: StringResource by lazy {
      StringResource("string:notes", "notes", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20821, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18217, 21),
      ))
    }

public val Res.string.nothing_to_cancel: StringResource by lazy {
      StringResource("string:nothing_to_cancel", "nothing_to_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 20847, 161),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18239, 141),
      ))
    }

public val Res.string.notifications: StringResource by lazy {
      StringResource("string:notifications", "notifications", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21009, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18381, 41),
      ))
    }

public val Res.string.november: StringResource by lazy {
      StringResource("string:november", "november", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21055, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18423, 28),
      ))
    }

public val Res.string.october: StringResource by lazy {
      StringResource("string:october", "october", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21103, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18467, 27),
      ))
    }

public val Res.string.ok: StringResource by lazy {
      StringResource("string:ok", "ok", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21131, 14),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18495, 14),
      ))
    }

public val Res.string.oldest: StringResource by lazy {
      StringResource("string:oldest", "oldest", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21146, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18510, 22),
      ))
    }

public val Res.string.onboarding_description1: StringResource by lazy {
      StringResource("string:onboarding_description1", "onboarding_description1", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21173, 187),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18533, 139),
      ))
    }

public val Res.string.onboarding_description2: StringResource by lazy {
      StringResource("string:onboarding_description2", "onboarding_description2", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21361, 167),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18673, 167),
      ))
    }

public val Res.string.only_support: StringResource by lazy {
      StringResource("string:only_support", "only_support", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21529, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18841, 72),
      ))
    }

public val Res.string.optimize_your: StringResource by lazy {
      StringResource("string:optimize_your", "optimize_your", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21618, 181),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 18914, 169),
      ))
    }

public val Res.string.password: StringResource by lazy {
      StringResource("string:password", "password", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22229, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19453, 28),
      ))
    }

public val Res.string.password_length: StringResource by lazy {
      StringResource("string:password_length", "password_length", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21800, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19084, 83),
      ))
    }

public val Res.string.password_set: StringResource by lazy {
      StringResource("string:password_set", "password_set", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 21888, 124),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19168, 104),
      ))
    }

public val Res.string.password_updated: StringResource by lazy {
      StringResource("string:password_updated", "password_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22013, 136),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19273, 116),
      ))
    }

public val Res.string.passwords_do_not_match: StringResource by lazy {
      StringResource("string:passwords_do_not_match", "passwords_do_not_match", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22150, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19390, 62),
      ))
    }

public val Res.string.personal_details: StringResource by lazy {
      StringResource("string:personal_details", "personal_details", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22258, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19482, 48),
      ))
    }

public val Res.string.phone: StringResource by lazy {
      StringResource("string:phone", "phone", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22426, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19634, 21),
      ))
    }

public val Res.string.phone_number: StringResource by lazy {
      StringResource("string:phone_number", "phone_number", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22385, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19597, 36),
      ))
    }

public val Res.string.phone_number_required: StringResource by lazy {
      StringResource("string:phone_number_required", "phone_number_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22311, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19531, 65),
      ))
    }

public val Res.string.places: StringResource by lazy {
      StringResource("string:places", "places", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22452, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19656, 22),
      ))
    }

public val Res.string.plan: StringResource by lazy {
      StringResource("string:plan", "plan", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22790, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19982, 20),
      ))
    }

public val Res.string.plan_active_until: StringResource by lazy {
      StringResource("string:plan_active_until", "plan_active_until", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22479, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19679, 73),
      ))
    }

public val Res.string.plan_and_assign: StringResource by lazy {
      StringResource("string:plan_and_assign", "plan_and_assign", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22553, 127),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19753, 127),
      ))
    }

public val Res.string.plan_downgrade_scheduled: StringResource by lazy {
      StringResource("string:plan_downgrade_scheduled", "plan_downgrade_scheduled", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22681, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 19881, 100),
      ))
    }

public val Res.string.powerful_tools: StringResource by lazy {
      StringResource("string:powerful_tools", "powerful_tools", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22811, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20003, 42),
      ))
    }

public val Res.string.pricing: StringResource by lazy {
      StringResource("string:pricing", "pricing", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22870, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20046, 27),
      ))
    }

public val Res.string.priority_support: StringResource by lazy {
      StringResource("string:priority_support", "priority_support", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22906, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20074, 68),
      ))
    }

public val Res.string.privacy_policy: StringResource by lazy {
      StringResource("string:privacy_policy", "privacy_policy", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 22991, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20143, 42),
      ))
    }

public val Res.string.profile_settings: StringResource by lazy {
      StringResource("string:profile_settings", "profile_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23042, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20186, 48),
      ))
    }

public val Res.string.provide_information: StringResource by lazy {
      StringResource("string:provide_information", "provide_information", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23095, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20235, 67),
      ))
    }

public val Res.string.publish_key: StringResource by lazy {
      StringResource("string:publish_key", "publish_key", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23163, 163),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20303, 163),
      ))
    }

public val Res.string.ready_for: StringResource by lazy {
      StringResource("string:ready_for", "ready_for", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23327, 77),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20467, 61),
      ))
    }

public val Res.string.register: StringResource by lazy {
      StringResource("string:register", "register", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23540, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20648, 28),
      ))
    }

public val Res.string.register_msg: StringResource by lazy {
      StringResource("string:register_msg", "register_msg", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23405, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20529, 92),
      ))
    }

public val Res.string.register_with: StringResource by lazy {
      StringResource("string:register_with", "register_with", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23510, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20622, 25),
      ))
    }

public val Res.string.reject: StringResource by lazy {
      StringResource("string:reject", "reject", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23573, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20677, 58),
      ))
    }

public val Res.string.remove_file: StringResource by lazy {
      StringResource("string:remove_file", "remove_file", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23652, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20736, 35),
      ))
    }

public val Res.string.repeat: StringResource by lazy {
      StringResource("string:repeat", "repeat", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23882, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20950, 22),
      ))
    }

public val Res.string.repeat_daily_weekday: StringResource by lazy {
      StringResource("string:repeat_daily_weekday", "repeat_daily_weekday", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23692, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20772, 48),
      ))
    }

public val Res.string.repeat_daily_workday: StringResource by lazy {
      StringResource("string:repeat_daily_workday", "repeat_daily_workday", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23741, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20821, 48),
      ))
    }

public val Res.string.repeat_interval: StringResource by lazy {
      StringResource("string:repeat_interval", "repeat_interval", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23794, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20870, 35),
      ))
    }

public val Res.string.repeat_password: StringResource by lazy {
      StringResource("string:repeat_password", "repeat_password", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23830, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20906, 43),
      ))
    }

public val Res.string.report_submitted: StringResource by lazy {
      StringResource("string:report_submitted", "report_submitted", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23913, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 20973, 64),
      ))
    }

public val Res.string.report_will_appear: StringResource by lazy {
      StringResource("string:report_will_appear", "report_will_appear", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 23982, 134),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21038, 98),
      ))
    }

public val Res.string.resend_confirmation_link: StringResource by lazy {
      StringResource("string:resend_confirmation_link", "resend_confirmation_link", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24117, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21137, 84),
      ))
    }

public val Res.string.reset_link_sent: StringResource by lazy {
      StringResource("string:reset_link_sent", "reset_link_sent", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24226, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21222, 47),
      ))
    }

public val Res.string.role: StringResource by lazy {
      StringResource("string:role", "role", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24444, 20),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21396, 20),
      ))
    }

public val Res.string.role_mandatory: StringResource by lazy {
      StringResource("string:role_mandatory", "role_mandatory", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24298, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21270, 30),
      ))
    }

public val Res.string.role_required: StringResource by lazy {
      StringResource("string:role_required", "role_required", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24333, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21301, 45),
      ))
    }

public val Res.string.roles_permission: StringResource by lazy {
      StringResource("string:roles_permission", "roles_permission", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24387, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21347, 48),
      ))
    }

public val Res.string.safety_requirements: StringResource by lazy {
      StringResource("string:safety_requirements", "safety_requirements", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24668, 119),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21576, 87),
      ))
    }

public val Res.string.safety_requirements_desc: StringResource by lazy {
      StringResource("string:safety_requirements_desc", "safety_requirements_desc", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24465, 88),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21417, 68),
      ))
    }

public val Res.string.safety_requirements_title: StringResource by lazy {
      StringResource("string:safety_requirements_title", "safety_requirements_title", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24554, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21486, 89),
      ))
    }

public val Res.string.saturday: StringResource by lazy {
      StringResource("string:saturday", "saturday", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24788, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21664, 28),
      ))
    }

public val Res.string.save_changes: StringResource by lazy {
      StringResource("string:save_changes", "save_changes", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24817, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21693, 36),
      ))
    }

public val Res.string.save_new_site: StringResource by lazy {
      StringResource("string:save_new_site", "save_new_site", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24866, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21730, 41),
      ))
    }

public val Res.string.save_password: StringResource by lazy {
      StringResource("string:save_password", "save_password", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24920, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21772, 41),
      ))
    }

public val Res.string.schedule: StringResource by lazy {
      StringResource("string:schedule", "schedule", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24992, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21844, 28),
      ))
    }

public val Res.string.scheduler: StringResource by lazy {
      StringResource("string:scheduler", "scheduler", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 24966, 25),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21814, 29),
      ))
    }

public val Res.string.search: StringResource by lazy {
      StringResource("string:search", "search", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25208, 22),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22008, 22),
      ))
    }

public val Res.string.search_map: StringResource by lazy {
      StringResource("string:search_map", "search_map", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25021, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21873, 34),
      ))
    }

public val Res.string.search_to_find: StringResource by lazy {
      StringResource("string:search_to_find", "search_to_find", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25080, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21908, 62),
      ))
    }

public val Res.string.search_users: StringResource by lazy {
      StringResource("string:search_users", "search_users", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25167, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 21971, 36),
      ))
    }

public val Res.string.select_dates: StringResource by lazy {
      StringResource("string:select_dates", "select_dates", setOf(
        ResourceItem(setOf(LanguageQualifier("de"), ), "${MD}values-de/strings.commonMain.cvr", 25231, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 22031, 36),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString3Resources(map: MutableMap<String, StringResource>) {
  map.put("never", Res.string.never)
  map.put("new_password", Res.string.new_password)
  map.put("new_workspace", Res.string.new_workspace)
  map.put("newest", Res.string.newest)
  map.put("next", Res.string.next)
  map.put("no", Res.string.no)
  map.put("no_completion_report", Res.string.no_completion_report)
  map.put("no_contacts_available", Res.string.no_contacts_available)
  map.put("no_damage", Res.string.no_damage)
  map.put("no_data_received", Res.string.no_data_received)
  map.put("no_dates_selected", Res.string.no_dates_selected)
  map.put("no_employees_added", Res.string.no_employees_added)
  map.put("no_hours_available", Res.string.no_hours_available)
  map.put("no_industries_available", Res.string.no_industries_available)
  map.put("no_information", Res.string.no_information)
  map.put("no_matching_industries", Res.string.no_matching_industries)
  map.put("no_matching_skills", Res.string.no_matching_skills)
  map.put("no_matching_teams", Res.string.no_matching_teams)
  map.put("no_plan_selected", Res.string.no_plan_selected)
  map.put("no_skills_available", Res.string.no_skills_available)
  map.put("no_tasks_assigned", Res.string.no_tasks_assigned)
  map.put("no_tasks_created", Res.string.no_tasks_created)
  map.put("no_tasks_text", Res.string.no_tasks_text)
  map.put("no_tasks_text_employee", Res.string.no_tasks_text_employee)
  map.put("no_tasks_yet", Res.string.no_tasks_yet)
  map.put("no_teams_available", Res.string.no_teams_available)
  map.put("no_working_hours_available", Res.string.no_working_hours_available)
  map.put("no_worries", Res.string.no_worries)
  map.put("not_assigned", Res.string.not_assigned)
  map.put("not_possible_to_buy_plan", Res.string.not_possible_to_buy_plan)
  map.put("not_scheduled", Res.string.not_scheduled)
  map.put("note_added_successfully", Res.string.note_added_successfully)
  map.put("note_deleted_successfully", Res.string.note_deleted_successfully)
  map.put("note_empty", Res.string.note_empty)
  map.put("note_updated_successfully", Res.string.note_updated_successfully)
  map.put("notes", Res.string.notes)
  map.put("nothing_to_cancel", Res.string.nothing_to_cancel)
  map.put("notifications", Res.string.notifications)
  map.put("november", Res.string.november)
  map.put("october", Res.string.october)
  map.put("ok", Res.string.ok)
  map.put("oldest", Res.string.oldest)
  map.put("onboarding_description1", Res.string.onboarding_description1)
  map.put("onboarding_description2", Res.string.onboarding_description2)
  map.put("only_support", Res.string.only_support)
  map.put("optimize_your", Res.string.optimize_your)
  map.put("password", Res.string.password)
  map.put("password_length", Res.string.password_length)
  map.put("password_set", Res.string.password_set)
  map.put("password_updated", Res.string.password_updated)
  map.put("passwords_do_not_match", Res.string.passwords_do_not_match)
  map.put("personal_details", Res.string.personal_details)
  map.put("phone", Res.string.phone)
  map.put("phone_number", Res.string.phone_number)
  map.put("phone_number_required", Res.string.phone_number_required)
  map.put("places", Res.string.places)
  map.put("plan", Res.string.plan)
  map.put("plan_active_until", Res.string.plan_active_until)
  map.put("plan_and_assign", Res.string.plan_and_assign)
  map.put("plan_downgrade_scheduled", Res.string.plan_downgrade_scheduled)
  map.put("powerful_tools", Res.string.powerful_tools)
  map.put("pricing", Res.string.pricing)
  map.put("priority_support", Res.string.priority_support)
  map.put("privacy_policy", Res.string.privacy_policy)
  map.put("profile_settings", Res.string.profile_settings)
  map.put("provide_information", Res.string.provide_information)
  map.put("publish_key", Res.string.publish_key)
  map.put("ready_for", Res.string.ready_for)
  map.put("register", Res.string.register)
  map.put("register_msg", Res.string.register_msg)
  map.put("register_with", Res.string.register_with)
  map.put("reject", Res.string.reject)
  map.put("remove_file", Res.string.remove_file)
  map.put("repeat", Res.string.repeat)
  map.put("repeat_daily_weekday", Res.string.repeat_daily_weekday)
  map.put("repeat_daily_workday", Res.string.repeat_daily_workday)
  map.put("repeat_interval", Res.string.repeat_interval)
  map.put("repeat_password", Res.string.repeat_password)
  map.put("report_submitted", Res.string.report_submitted)
  map.put("report_will_appear", Res.string.report_will_appear)
  map.put("resend_confirmation_link", Res.string.resend_confirmation_link)
  map.put("reset_link_sent", Res.string.reset_link_sent)
  map.put("role", Res.string.role)
  map.put("role_mandatory", Res.string.role_mandatory)
  map.put("role_required", Res.string.role_required)
  map.put("roles_permission", Res.string.roles_permission)
  map.put("safety_requirements", Res.string.safety_requirements)
  map.put("safety_requirements_desc", Res.string.safety_requirements_desc)
  map.put("safety_requirements_title", Res.string.safety_requirements_title)
  map.put("saturday", Res.string.saturday)
  map.put("save_changes", Res.string.save_changes)
  map.put("save_new_site", Res.string.save_new_site)
  map.put("save_password", Res.string.save_password)
  map.put("schedule", Res.string.schedule)
  map.put("scheduler", Res.string.scheduler)
  map.put("search", Res.string.search)
  map.put("search_map", Res.string.search_map)
  map.put("search_to_find", Res.string.search_to_find)
  map.put("search_users", Res.string.search_users)
  map.put("select_dates", Res.string.select_dates)
}
